'use client';
import { noop } from '@mantine/core';
import { useElementSize } from '@mantine/hooks';
import { createContext, useContext, useCallback, useMemo, useRef, useState } from 'react';
export const GoodTableContext = createContext({
    attachTableRef: noop,
    attachOuterRef: noop,
    attachScrollRef: noop,
    scrollPosition: { x: 0, y: 0 },
    outerWidth: 0,
    scrollWidth: 0,
    scrollTo: noop,
    overflowX: 0,
    onScrollPositionChange: noop,
});
export const GoodTableProvider = ({ children }) => {
    const [scrollPosition, setScrollPosition] = useState({
        x: 0,
        y: 0,
    });
    const { width: scrollWidth, ref: tableRef } = useElementSize();
    const { width: outerWidth, ref: outerRef } = useElementSize();
    const scrollRef = useRef(null);
    const overflowX = Math.max(scrollWidth - outerWidth, 0);
    const attachOuterRef = useCallback((node) => {
        // @ts-expect-error
        outerRef.current = node;
    }, [outerRef]);
    const attachScrollRef = useCallback((node) => {
        // @ts-expect-error
        scrollRef.current = node;
    }, []);
    const attachTableRef = useCallback((node) => {
        // @ts-expect-error
        tableRef.current = node;
    }, [tableRef]);
    const scrollTo = useCallback((left) => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({
                left,
            });
        }
    }, []);
    const onScrollPositionChange = useCallback((position) => {
        setScrollPosition(position);
    }, []);
    const value = useMemo(() => ({
        attachOuterRef,
        attachScrollRef,
        attachTableRef,
        onScrollPositionChange,
        outerWidth,
        overflowX,
        scrollPosition,
        scrollTo,
        scrollWidth,
    }), [
        attachOuterRef,
        attachScrollRef,
        attachTableRef,
        onScrollPositionChange,
        outerWidth,
        overflowX,
        scrollPosition,
        scrollTo,
        scrollWidth,
    ]);
    return <GoodTableContext.Provider value={value}>{children}</GoodTableContext.Provider>;
};
export const useGoodTableContext = () => useContext(GoodTableContext);
